import { render, staticRenderFns } from "./AudioEdit.vue?vue&type=template&id=0853042a&"
import script from "./AudioEdit.vue?vue&type=script&lang=js&"
export * from "./AudioEdit.vue?vue&type=script&lang=js&"
import style0 from "./AudioEdit.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports